<script setup>
import CampaignCard from 'dashboard/components-next/Campaigns/CampaignCard/CampaignCard.vue';

defineProps({
  campaigns: {
    type: Array,
    required: true,
  },
  isLiveChatType: {
    type: Boolean,
    default: false,
  },
  isWhatsAppType: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['edit', 'delete', 'open']);

const handleEdit = campaign => emit('edit', campaign);
const handleOpen = campaign => emit('open', campaign);
const handleDelete = campaign => emit('delete', campaign);
</script>

<template>
  <div class="flex flex-col gap-4">
    <CampaignCard
      v-for="campaign in campaigns"
      :key="campaign.id"
      :title="campaign.title"
      :message="campaign.message"
      :is-enabled="campaign.enabled"
      :status="campaign.campaign_status"
      :sender="campaign.sender"
      :inbox="campaign.inbox"
      :scheduled-at="campaign.scheduled_at"
      :is-live-chat-type="isLiveChatType"
      :is-whats-app-type="isWhatsAppType"
      :audience="campaign.audienceLabel"
      :template-name="campaign.template_params?.name"
      :dispatch="campaign.dispatch"
      :delivery="campaign.delivery"
      @edit="handleEdit(campaign)"
      @open="handleOpen(campaign)"
      @delete="handleDelete(campaign)"
    />
  </div>
</template>
